import React, { useState } from "react";
import { Typography, Button, Grid, TextField, FormControl, Paper } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { forgotPassword } from "../../../actions/loginActions";
import { useStateValue } from "../../../context/store";
import LoginContainer from "../LoginContainer";
import EmailIcon from '@material-ui/icons/Email';
import InputAdornment from "@material-ui/core/InputAdornment";
import { styles }  from  '../styles';


const style = {
    paper: {
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        marginLeft: "25px"
    },
    form: {
        width: "100%",
    },
    password: {
    },
    submit: {
        background: '#666666',
        color: 'white',
        marginTop: "10px",
        width: "100%",
        marginBottom: 20,
        '&:hover': {
            color: 'white',
            background: '#099F9F'
        }
    },
    error: {
        "&.MuiFormHelperText-root.Mui-error": {
            color: "red"
        }
    },
  
};

const Recovery = (props) => {
    const classes = styles();

    const [{ }, dispatch] = useStateValue();
    const [validEmail, setValidEmail] = useState(false);
    const [email, setEmail] = useState("");
    const [isVerified, setIsVerified] = useState(false);

    let validateEmail = (email) => {
        let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRegex.test(email)) {
            setValidEmail(false);
        }
        else {
            setValidEmail(true);
        }
    }

    const addValuesToMemory = (e) => {
        const { name, value } = e.target;
        if (name === "email") {
            validateEmail(value);
        }
        setEmail(value);
    };

    const forgotPasswordBtn = (e) => {
        e.preventDefault();
        props.history.push("/auth/validate")
        if (email === "") { return; }
        if (!isVerified) { return; }
        forgotPassword(email, dispatch).then((response) => {
            if (response.status === 200 || response.code === 200) {
                props.history.push("/auth/success");
            } else {
                props.history.push("/auth/upps");
            }
        }, error => {
            props.history.push("/auth/upps");
        });
    };

    const recoveryComponent = () => (
        <Grid container spacing={0}>
                <Grid sm={12} md={12} lg = {12}>
                    <Paper style={style.paper} elevation={0}>
                        <Typography
                            className = { classes.titleOneRecovery }
                        >
                            RECUPERACIÓN DE CONTRASEÑA
                        </Typography>
                        <Typography
                            className = { classes.titleTwo }
                        >
                            Llegará Un Enlace Para Restablecer Su Contraseña
                        </Typography>
                        <form style={style.form}>
                            <Grid item sm ={12} md = {12} lg = {12} >
                            <FormControl  fullWidth className={classes.margin}>
                                <TextField
                                    error={validEmail}
                                    value={email}
                                    onChange={addValuesToMemory}
                                    style={style.password}
                                    variant="outlined"
                                    label="Correo electrónico"
                                    placeholder = 'Ingresa aquí tu correo'
                                    name="email"
                                    fullWidth
                                    margin="normal"
                                    InputProps={{
                                        startAdornment: (
                                          <InputAdornment position="start">
                                            <EmailIcon />
                                          </InputAdornment>
                                        ),
                                      }}
                                    helperText={validEmail ? "Introduzca una dirección de correo electrónico válida" : ""}
                                />
                            </FormControl>
                            </Grid>
                            <Grid container spacing={1} style={{justifyContent: 'center', margin: '8% 0px 20% 0px'}}>
                                <Grid item xs={12} sm={12} md={6}> 
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        className = { classes.submit }
                                        onClick={forgotPasswordBtn}
                                        disabled={validEmail}
                                        disableElevation
                                    >
                                        Entrar
                                    </Button>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        className = { classes.buttonBack }
                                        onClick={forgotPasswordBtn}
                                        disabled={validEmail}
                                        disableElevation
                                    >
                                        Regresar
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Paper>
                </Grid>
            </Grid>
    )

    return (
        <LoginContainer >
            {recoveryComponent()}
        </LoginContainer>
    );
};

export default withRouter(Recovery);
